module.exports = __webpack_public_path__ + "img/7.8d290180.jpg";